import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import * as Sentry from "@sentry/react";
import { composeWithDevTools } from "redux-devtools-extension";
import mainReducer from "../pages/reducer";

const rootReducer = combineReducers({
  main: mainReducer,
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action: any) => {
    if (action.type === "MAIN_SET_USER_DATA") {
      return {
        ...action,
        accessToken: null,
      };
    }
    return action;
  },
  stateTransformer: (state: any) => {
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      accessToken: "token",
    };

    return transformedState;
  },
});

const composeEnhancers = composeWithDevTools({});

export type RootState = ReturnType<typeof rootReducer>;

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk), sentryReduxEnhancer));

export type AppDispatch = typeof store.dispatch;

export default rootReducer;
